'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEndpointSnappedToAngle = undefined;

var _Vector = require('../../../common/maths/geometry/Vector');

var _Vector2 = _interopRequireDefault(_Vector);

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var SNAP_ANGLE = 45;
var DIAGONALLY_DOWN_RIGHT_ANGLE = -45;
var DIAGONALLY_UP_LEFT_ANGLE = 135;
var HORIZONTAL_ANGLE = 180;
var VERTICAL_ANGLE = 90;

var matchDiagonal = function matchDiagonal(inverse) {
    return function (vector) {
        var factor = inverse ? -1 : 1;
        if (Math.abs(vector.x) > Math.abs(vector.y)) return new _Vector2.default(vector.x, factor * vector.x);
        return new _Vector2.default(factor * vector.y, vector.y);
    };
};
var matchHorizontal = function matchHorizontal(vector) {
    return new _Vector2.default(vector.x, 0);
};
var matchVertical = function matchVertical(vector) {
    return new _Vector2.default(0, vector.y);
};

var getSnapAngleRule = function getSnapAngleRule(snappedAngle) {
    if (snappedAngle % HORIZONTAL_ANGLE === 0) return matchHorizontal;
    if (snappedAngle % VERTICAL_ANGLE === 0) return matchVertical;
    var inverseDiagonal = snappedAngle === DIAGONALLY_DOWN_RIGHT_ANGLE || snappedAngle === DIAGONALLY_UP_LEFT_ANGLE;
    return matchDiagonal(inverseDiagonal);
};

var getClosestSnappedAngle = function getClosestSnappedAngle(vector) {
    return Math.round(vector.angleDeg() / SNAP_ANGLE) * SNAP_ANGLE;
};

var getEndpointSnappedToAngle = exports.getEndpointSnappedToAngle = function getEndpointSnappedToAngle(_ref) {
    var fixedPoint = _ref.fixedPoint,
        flexiblePoint = _ref.flexiblePoint;

    // Get the vector between the start and end points
    var lineVector = _Vector2.default.fromObject(pointLib.difference(fixedPoint, flexiblePoint));
    // Figure out the closest angle that it should snap to
    var snappedAngle = getClosestSnappedAngle(lineVector);
    // Get the appropriate rule for updating the vector
    var snappedAngleRule = getSnapAngleRule(snappedAngle);
    // Update the vector according to the snapped angle's rule
    var updatedVector = snappedAngleRule(lineVector);
    // Translate the vector back into its original coordinates
    return pointLib.translate(fixedPoint, updatedVector);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/lineSnapAngleUtil.js
// module id = 737
// module chunks = 0